import { DI } from '@intigral/constant/config/DIContainer';
import { IHttpAdapter } from '../../core/entities/iHttpAdapter';
import { container } from '../../DataDomain';
import { IApiPathManager } from '../config/ApiPathManager';
import { ICMSCarouselRepository } from '../../core/repositories/interfaces/ICMSCarouselRepository';
import { IGetCatchUpListParams, IGetCatchUpListResponse } from '../../entity/interface/iCmsCarousel';
import { API_IDS } from '@intigral/constant';

class CMSCarouselRepository implements ICMSCarouselRepository {
    // Lazy getters for dependencies to avoid circular dependencies
    private get http(): IHttpAdapter {
        return container.resolve<IHttpAdapter>(DI.UTILS.IHttpAdapter);
    }

    private get apiPathManager(): IApiPathManager {
        return container.resolve<IApiPathManager>(DI.UTILS.IApiPathManager);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async getCatchUpCarousel(
        dataSource: string,
        apiKey: string,
        params?: IGetCatchUpListParams,
        isMixedCatchup?: boolean
    ): Promise<IGetCatchUpListResponse> {
        let pathUrl = dataSource;
        if (!pathUrl) {
            pathUrl = isMixedCatchup
                ? this.apiPathManager.getPath(API_IDS.MIXED_CATCH_UP_CAROUSEL_LIST)
                : this.apiPathManager.getPath(API_IDS.CATCH_UP_CAROUSEL_LIST);
        }
        const url = this.apiPathManager.replacePlaceholders(pathUrl);
        const response = await this.http.get<IGetCatchUpListResponse>(url, {
            params: {
                ...params,
                apiKey,
            },
        });
        return response.data;
    }
}

export default CMSCarouselRepository;
